export default __webpack_public_path__ + "static/media/cpv_98_other.cc764cc0.svg";